import * as $ from 'jquery';
declare global {

    /*eslint-disable */
    interface Window {
        dataLayer: any;
    }
    /*eslint-enable */
}
export function sendEvent(
    event: string,
    items?: Array<AnalyticsItem>,
    properties?: AnalyticsObject
): void {
    
    if (typeof window !== 'undefined') {
        properties = {
            ...properties,
            event: event,
        };
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({ ecommerce: null });
            
            window.dataLayer.push({
                ...properties,
                ecommerce: {
                    items: items,
                },
            });
        }
    }
}

export function dataLayerPush(properties?: AnalyticsObject): void {
    if (typeof window !== 'undefined') {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                ...properties,
            });
        }
    }
}

export type AnalyticsItem = {
    item_id: string;
    item_name?: string;
    price?: number;
    quantity?: number;
    item_category?: string;
    currency?: string;
};
export type AnalyticsObject = {
    pageId?: number;
    pageTitle?: string;
    documentType?: string;
    pageURL?: string;
    event?: string;
    color?: string;
    question?: string;
    answer?: string;
    nrOfSources?: number;
    formName?: string;
    typeOfForm?: string;
    query: string;
};